import { render, staticRenderFns } from "./ModalFile.vue?vue&type=template&id=3050ff25&scoped=true"
import script from "./ModalFile.vue?vue&type=script&lang=js"
export * from "./ModalFile.vue?vue&type=script&lang=js"
import style0 from "./ModalFile.vue?vue&type=style&index=0&id=3050ff25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3050ff25",
  null
  
)

export default component.exports